import { useMemo } from 'react';

import { api, FctReport } from '@/api';
import { useUser } from '@/core/user/user.hook';

import { useStudyGuard } from '../guard';

interface UseFctReport {
  report?: FctReport;
}

export function useFctReport(): UseFctReport {
  const {
    patient: { gender },
    studyId,
  } = useStudyGuard();
  const { user } = useUser();

  const { data } = api.fct.report.query.useGetReportStudy(
    { payload: { params: { patient_gender: gender, user_id: user.user_id }, studyId } },
    { enabled: false },
  );

  const value = useMemo(() => ({ report: data }), [data]);

  return value;
}
